//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "FooterComponent"
};
